/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useAuth} from '../../../../app/modules/auth'
import {useUserProfile} from '../../../../app/hooks/useUserProfile'
import {KTIcon} from '../../../helpers'
import {useThemeMode} from '../theme-mode/ThemeModeProvider'
import {useIntl} from 'react-intl'

const HeaderUserMenu: FC = () => {
  const intl = useIntl()
  const {auth, currentUser, logout} = useAuth()
  const {data: profile} = useUserProfile()
  const {menuMode, updateMode, updateMenuMode} = useThemeMode()
  const user = currentUser || auth?.user
  const displayName = profile?.name || user?.name || user?.username || 'User'
  const displayInitial = displayName.substr(0, 1).toUpperCase()
  const displayEmail = profile?.email || user?.email || ''
  const isKybPending = auth?.flow === 'kyb'
  const kybDisabledStyle: React.CSSProperties = isKybPending
    ? { pointerEvents: 'none', opacity: 0.5 }
    : {}

  const switchMode = (_mode: 'light' | 'dark' | 'system') => {
    updateMenuMode(_mode)
    updateMode(_mode)
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <div
              className='d-flex align-items-center justify-content-center symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'
              style={{height: '50px', width: '50px', backgroundColor: '#E8912D', fontSize: '30px'}}
            >
              {displayInitial}
            </div>
          </div>

          <div className='d-flex flex-column align-items-start'>
            {user?.user_subscriptions?.[0]?.name && (
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1'>
                {user.user_subscriptions[0].name}
              </span>
            )}
            <div className='fw-bolder d-flex align-items-center fs-5'>{displayName}</div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {displayEmail}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5' style={kybDisabledStyle}>
        <Link to={'/profile/overview'} className='menu-link px-5'>
          {intl.formatMessage({ id: 'MENU.MY_PROFILE' })}
        </Link>
      </div>

      <div className='menu-item px-5' style={kybDisabledStyle}>
        <Link to={'/support?tab=contactUs'} className='menu-link px-5'>
          {intl.formatMessage({ id: 'MENU.CONTACT_US' })}
        </Link>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <div className='menu-content d-flex align-items-center px-3 py-1'>
          <span className='fw-semibold text-muted fs-7 me-auto'>{intl.formatMessage({ id: 'MENU.THEME' })}</span>
          <div className='d-flex gap-1'>
            <a
              href='#'
              onClick={() => switchMode('light')}
              className={clsx('btn btn-sm btn-icon', menuMode === 'light' ? 'btn-primary' : 'btn-light')}
            >
              <KTIcon iconName='night-day' className='fs-3' />
            </a>
            <a
              href='#'
              onClick={() => switchMode('dark')}
              className={clsx('btn btn-sm btn-icon', menuMode === 'dark' ? 'btn-primary' : 'btn-light')}
            >
              <KTIcon iconName='moon' className='fs-3' />
            </a>
            <a
              href='#'
              onClick={() => switchMode('system')}
              className={clsx('btn btn-sm btn-icon', menuMode === 'system' ? 'btn-primary' : 'btn-light')}
            >
              <KTIcon iconName='screen' className='fs-3' />
            </a>
          </div>
        </div>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          {intl.formatMessage({ id: 'MENU.SIGN_OUT' })}
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
